import * as React from 'react';

import { Spinner, Text } from '@components/common';
import { CheckSVG, NextStepsSVG, SearchSVG, SummaryChartSVG } from '@components/svgs';

import { MainAgentState } from './types';

type Props = {
  state: MainAgentState;
};

const Step: React.FC<{
  completed: boolean;
  icon: React.ReactNode;
  text: string;
}> = ({ completed, icon, text }) => (
  <div className='flex items-center space-x-2'>
    {completed ? <CheckSVG className='h-4 w-4 text-green-500' /> : icon}
    <Text h='400' bold color={completed ? 'gray-700' : 'gray-400'}>
      {text}
    </Text>
  </div>
);

export const Generative: React.FC<Props> = ({ state }) => {
  const { study, questions = [] } = state;
  const { research_goal, style, id } = study || {};

  return (
    <div className='flex h-full justify-center py-4'>
      <div className='space-y-4'>
        <div className='flex justify-center'>
          <Spinner className='h-8 w-8' />
        </div>
        <div className='space-y-2'>
          <Text className='text-center text-gray-500' bold h='400'>
            {questions.length > 0 ? 'Updating your research study...' : 'Building your research study...'}
          </Text>
          {questions.length === 0 && (
            <>
              <Step
                completed={!!research_goal}
                icon={<NextStepsSVG className='h-4 w-4' />}
                text={research_goal ? 'Goal generated' : 'Generating goal...'}
              />
              <Step
                completed={!!style}
                icon={<SummaryChartSVG className='h-4 w-4' />}
                text={style ? 'Method selected' : 'Selecting method...'}
              />
              <Step
                completed={!!id}
                icon={<NextStepsSVG className='h-4 w-4' />}
                text={id ? 'Study created' : 'Creating study...'}
              />
              <Step
                completed={questions.length > 0}
                icon={<SearchSVG className='h-4 w-4' />}
                text={questions.length > 0 ? 'Questions generated' : 'Generating questions...'}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
